import React, { Fragment } from 'react';
import Select from '~/js/components/general/Select';

import scheduleData from './data/schedule';

import ScheduleTable from './ScheduleTable';

const { resortList } = window.beaches_app.page;

const filteredResorts = resortList.filter(resort => resort.code !== 'BBO');



export default class ResortSchedule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      resortChecked: {
        [filteredResorts[0].code]: filteredResorts[0]
      }
    };
  }

  onChange = (item, multiselect) => {
    this.setState((prevState) => {
      let resortChecked = { ...prevState.resortChecked };

      if (multiselect) {
        if (resortChecked.hasOwnProperty(item.code)) {
          delete resortChecked[item.code];
        } else {
          resortChecked[item.code] = item;
        }
      } else {
        resortChecked = { [item.code]: item };
      }

      return { resortChecked, clickedCell: [] };
    });
  }

  cellClickedHandler = (rowIndex, cellIndex, actIndex) => {
    this.setState({ clickedCell: [rowIndex, cellIndex, actIndex] });
  }

  closeTooltipHandler = (e) => {
    e.stopPropagation();
    this.setState({ clickedCell: [] });
  }

  clickOutSide = () => {
    this.setState({ clickedCell: [] });
  }

  scrollLeft = () => {
    if (this.tableWrapperNode.scrollLeft) {
      this.tableWrapperNode.scrollLeft -= 160;
    }
  }

  scrollRight = () => {
    const scrollWidth = this.tableNode.offsetWidth - this.tableWrapperNode.offsetWidth;

    if (this.tableWrapperNode.scrollLeft <= scrollWidth) {
      this.tableWrapperNode.scrollLeft += 160;
    }
  }

  render() {
    const { resortChecked, clickedCell } = this.state;
    const checkedResort = Object.keys(resortChecked)[0];

    let table;

    if (checkedResort) {
      table = (
        <ScheduleTable
          data={scheduleData[checkedResort.toLowerCase()]}
          clickedCell={clickedCell}
          cellClickedHandler={this.cellClickedHandler}
          closeTooltipHandler={this.closeTooltipHandler}
          clickOutSide={this.clickOutSide}
          wrapRef={(node) => (this.tableWrapperNode = node)}
          tableRef={(node) => (this.tableNode = node)}
          scrollLeft={this.scrollLeft}
          scrollRight={this.scrollRight}/>
      );
    }

    return(
      <Fragment>
        <div className="row">
          <div className="xl-5 lg-8 xs-12 center">
            <h3 className="schedule-title txt-center uppercase">Select a Resort for schedule</h3>
            <Select
              theme="resorts"
              data={filteredResorts}
              placeholder="Select Resort!"
              markedKey="code"
              labelKey="shortName"
              checked={resortChecked}
              groupByKey="countryName"
              onChange={this.onChange}
              onOpen={() => this.setState({ clickedCell: [] })}
            />
          </div>
        </div>

        {table}
      </Fragment>
    );
  }
}
